import { Close as CloseIcon } from '@mui/icons-material';
import {
  Box,
  Drawer,
  DrawerProps,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import React, { ReactNode } from 'react';

type Props = {
  open: boolean;
  title: ReactNode;
  children: ReactNode;
  onClose: () => void;
  width: number;
  drawerProps?: DrawerProps;
};

export const Sidebar: React.FC<Props> = ({
  open,
  title,
  children,
  onClose,
  width,
  drawerProps,
}: Props) => {
  const theme = useTheme();
  return (
    <Drawer
      sx={{
        flexShrink: 0,
        width: 0,
      }}
      slotProps={{
        paper: {
          sx: {
            zIndex: 1100,
            width,
            borderLeftWidth: 1,
          },
        },
      }}
      anchor="right"
      open={open}
      hideBackdrop
      disableScrollLock
      {...drawerProps}
      onClose={onClose}
    >
      <div
        className="tw-fixed tw-flex tw-items-center tw-justify-between tw-py-2 tw-px-4 tw-z-10"
        style={{ width, backgroundColor: theme.palette.background.paper }}
      >
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Box sx={{ px: 4, pb: 2, width, marginBottom: 4, marginTop: 14 }}>
        {children}
      </Box>
    </Drawer>
  );
};
